<!--suppress ALL -->
<template>
  <div>
    <div class="padding15">
      <el-form size="small" label-width="100px" ref="searchRef">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="意图包名称">
              <el-input
                v-model="searchReq.confName"
                placeholder="请输入意图包名称"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态">
              <el-select v-model="searchReq.status" filterable clearable placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in stateList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="创建时间">
              <el-date-picker v-model="searchReq.startTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="至">
              <el-date-picker v-model="searchReq.endTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
            </el-form-item>
          </el-col>
          <!-- 按钮操作 -->
          <el-col :span="8" class="text right">
            <el-button type="primary" size="small" plain @click="searchReq.page = 1; getList();"><i class="fa fa-search"></i> 搜索</el-button>
            <el-button size="small" @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="bg-content">
      <el-button
        type="primary"
        icon="el-icon-plus"
        size="mini"
        @click="handleAdd"
      >新增</el-button>
      <el-button
        type="danger"
        icon="el-icon-delete"
        size="mini"
        :disabled="multiple"
        @click="handleDelByIds"
      >删除</el-button>
      <br/><br/>
      <el-table size="small" :data="conditionList.list" v-loading="loading" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column fixed label="意图包名称" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-button type="text" @click="linkDetailIndex(scope.row)">{{scope.row.confName}}</el-button>
          </template>
        </el-table-column>
        <el-table-column fixed property="status"  label="状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status">有效</span>
            <span v-else>无效</span>
          </template>
        </el-table-column>
        <el-table-column fixed property="createTime"  label="创建时间"  align="center"/>
        <el-table-column fixed label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="updateButton(scope.row)"><i class="el-icon-edit-outline"></i>&nbsp;编辑</el-button>
            <el-button type="text" icon="el-icon-delete" size="mini" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="text center margin15-tb">
        <el-pagination
          background
          layout="prev, pager, next, sizes, total"
          :total="conditionList.totalRecords"
          :page-size="searchReq.limit"
          :current-page="searchReq.page"
          @current-change="currentChange"
          @size-change="sizeChange">
        </el-pagination>
      </div>
    </div>
    <!--    编辑    -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="意图包名称" prop="confName">
          <el-input v-model="form.confName" placeholder="请输入意图包名称" />
        </el-form-item>
        <el-form-item label="意图包状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio
              v-for="dict in stateList"
              :key="dict.value"
              :label="dict.value"
            >{{ dict.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确认</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      searchReq: {
        confName: null,
        status: null,
        startTime: null,
        endTime: null,
        page: 1,
        limit: 10,
        order: 'create_time',
        sort: 'desc'
      },
      conditionList: { 'totalRecords': 0, list: [] },
      stateList: [
        { value: true, label: '有效' },
        { value: false, label: '无效' }
      ],
      // 表单参数
      form: {
        status: false,
        confName: null
      },
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      this.$ajax({
        method: 'get',
        url: '/intentionConf/list',
        params: this.searchReq
      }).then((res) => {
        this.conditionList.list = res.data.list;
        this.conditionList.totalRecords = res.data.totalRecords;
        this.loading = false;
      });
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    updateButton(row) {
      this.title = '编辑意图包';
      this.form.id = row.id;
      this.form.confName = row.confName;
      this.form.status = row.status;
      this.open = true;
    },
    handleAdd() {
      this.title = '添加意图包';
      this.form.id = null;
      this.form.confName = null;
      this.form.status = true;
      this.open = true;
    },
    // 重置
    reset() {
      this.searchReq.confName = null;
      this.searchReq.status = null;
      this.searchReq.startTime = null;
      this.searchReq.endTime = null;
    },
    currentChange(page) {
      this.searchReq.page = page;
      this.getList();
    },
    // 显示条数
    sizeChange(num) {
      this.searchReq.limit = num;
      this.getList();
    },
    submitForm() {
      if (this.form.id) {
        this.$ajax({
          method: 'post',
          url: '/intentionConf/update',
          data: this.form
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
            this.open = false;
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        });
      } else {
        this.$ajax({
          method: 'post',
          url: '/intentionConf/save',
          data: this.form
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
            this.open = false;
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        });
      }
    },
    cancel() {
      this.open = false;
      this.reset();
    },
    handleDelByIds() {
      this.$confirm('是否确认删除 ?', '警告', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          method: 'delete',
          url: '/intentionConf/del',
          data: this.ids
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        }).finally(() => {
          this.getList();
        });
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      this.$confirm(`是否确认删除条件意图包：${row.confName} ?`, '警告', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          method: 'delete',
          url: `/intentionConf/del/${row.id}`
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        }).finally(() => {
          this.getList();
        });
      });
    },
    linkDetailIndex(row) {
      sessionStorage.setItem('changeConfId', row.id);
      sessionStorage.setItem('intentionConfName', row.confName);
      this.$emit('showbox', '意图配置');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/collection/intention/conf/conf_index.vue